import { getRequest, postRequest, getcontractIdNumber } from './api'
import { API_URL } from '../constants/index'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`
  return getRequest(
    `${API_URL}address/get-list/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy ||
      '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`${API_URL}address/edit/${id}`)
}

export async function save(values) {
  return postRequest(`${API_URL}address/save`, values)
}

export function remove(id) {
  // POST variant (not the DELETE verb): deleteRequest() swallows 4xx bodies and
  // returns null, which would hide the "address is in use" block message. The
  // POST endpoint's 400 body reaches the saga so it can be shown.
  return postRequest(`${API_URL}address/delete`, { values: { DeleteID: id } })
}

export async function importData(values) {
  console.log('importData', values)
  const headers = {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
  }
  return postRequest(`${API_URL}address/import`, values, headers)
}
